import React from 'react';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { ExcludeFromDebtManagement } from '../../components/ExcludeFromDebtManagement/ExcludeFromDebtManagement';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { InterestRate } from '../../components/InterestRate/InterestRate';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';
import { MonthlyContribution } from '../../components/MonthlyContribution/MonthlyContribution';
import { OriginationDate } from '../../components/OriginationDate/OriginationDate';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnership />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Balance" />
      <InterestRate label="Interest Rate" />
      <MonthlyContribution label="Monthly Payment" />
      <ManagementStyle />
      <AssetBucketing />
      <OriginationDate />
      <ExcludeFromDebtManagement />
    </TabWrapper>
  );
};

export const OtherLoans = (props: FormComponentProps) => {
  return <TabsContent {...props} tabs={[{ name: 'Summary', Component: Summary }]} />;
};
